<div class="player-box" [class.has-paywall]="paywallVisible" [class.hidden]="!paywallVisible && mode == 'podcasts'">
  <media-player
    #player
    [inline]="true"
    [autoplay]="false"
    (paywallVisible)="paywallVisible = $event"
    [inEditor]="inEditor"
    (currentItemChanged)="updateItem($event)">
  </media-player>

  <noscript *ngIf="!enableNoJsMediaPlayer">
    You must enable Javascript to watch this video
  </noscript>
  <no-js-media-player
    *ngIf="enableNoJsMediaPlayer"
    [asset]="currentlyPlayingVOD?.asset || currentlyPlayingPodcast?.asset"
    [type]="currentlyPlayingVOD ? 'video' : 'audio'"
    >
    </no-js-media-player>
</div>
<div *ngIf="mode == 'podcasts' && !paywallVisible && item" class="podcast-player">
  <div class="current-item" *ngIf="item">
    <div class="production-date">{{production.date_simple | date : 'mediumDate'}}</div>
    <h1>
      {{title}}
    </h1>

    <div>
      <ng-container *ngIf="item.is_premium && !item.unlock_premium">
        <tyt-plus-tag *ngIf="audienceType === 'member'"></tyt-plus-tag>
        <tyt-plus-locked *ngIf="audienceType !== 'member'"></tyt-plus-locked>
      </ng-container>
      <tyt-plus-unlocked *ngIf="item.unlock_premium"></tyt-plus-unlocked>
    </div>

    <ul class="stats">
      <li>{{item.duration | duration}}</li>
      <li>
        <tyt-comments-count [identifier]="topicIdentifier"></tyt-comments-count>
      </li>
      <li *ngIf="showEditLink"><a routerLink="/watch/edit/{{production.id}}/{{mode}}/{{item.id}}">Edit</a></li>
    </ul>

  </div>
  <tyt-remote-audio-player></tyt-remote-audio-player>
</div>

<div class="current-item" *ngIf="mode != 'podcasts' && item">

  <div id="play-options" *ngIf="item && currentlyPlayingVOD?.asset" [class.open]="showPlaybackOptions">
    <a class="opener" href="javascript:;" (click)="showPlaybackOptions = !showPlaybackOptions"
      aria-label="Playback Options">
      <mat-icon>settings</mat-icon>
      <span class="options-label" *ngIf="showPlaybackOptions">Playback Options</span>
      <div class="spacer">
      </div>
      <mat-icon *ngIf="showPlaybackOptions">expand_less</mat-icon>
      <mat-icon *ngIf="!showPlaybackOptions">expand_more</mat-icon>
    </a>
    <div class="option-list">
      <hr />
      <ng-container *ngIf="!entitled">
        <a routerLink="{{loginOrJoinUrl}}">
          <mat-icon>download_for_offline</mat-icon>
          Download HD [members only]
        </a>
        <a routerLink="{{loginOrJoinUrl}}">
          <mat-icon>download_for_offline</mat-icon>
          Download SD [members only]
        </a>
        <a routerLink="{{loginOrJoinUrl}}">
          <mat-icon>download_for_offline</mat-icon>
          Download Audio [members only]
        </a>
      </ng-container>
      <ng-container *ngIf="entitled">
        <a [class.unavailable]="!currentlyPlayingVOD.asset.hd_video_download_url"
          href="{{currentlyPlayingVOD.asset.hd_video_download_url}}" title="Right click or long tap to download"
          target="_blank">
          <mat-icon>download_for_offline</mat-icon>
          Download HD
          <span class="not-available-text" *ngIf="!currentlyPlayingVOD.asset.hd_video_download_url">[not
            available]</span>
        </a>
        <a [class.unavailable]="!currentlyPlayingVOD.asset.sd_video_download_url"
          href="{{currentlyPlayingVOD.asset.sd_video_download_url}}" title="Right click or long tap to download"
          target="_blank">
          <mat-icon>download_for_offline</mat-icon>
          Download SD
          <span class="not-available-text" *ngIf="!currentlyPlayingVOD.asset.sd_video_download_url">[not
            available]</span>
        </a>
        <a [class.unavailable]="!currentlyPlayingVOD.asset.audio_download_url"
          href="{{currentlyPlayingVOD.asset.audio_download_url}}" title="Right click or long tap to download"
          target="_blank">
          <mat-icon>download_for_offline</mat-icon>
          Download
          <span class="not-available-text" *ngIf="!currentlyPlayingVOD.asset.audio_download_url">[not
            available]</span>
        </a>
      </ng-container>

      <hr />

      <em class="explanation">Note: You may need to right click or long tap on the link and select 'Save
        File'</em>
    </div>
  </div>

  <div class="production-date">{{production.date_simple | date : 'mediumDate'}}</div>
  <h1>
    {{title}}
  </h1>

  <div class="description" [innerHTML]="item.description | newlinesToHtml | linksToHtml | trustHtml"></div>

  <div>
    <ng-container *ngIf="item.is_premium && !item.unlock_premium">
      <tyt-plus-tag *ngIf="audienceType === 'member'"></tyt-plus-tag>
      <tyt-plus-locked *ngIf="audienceType !== 'member'"></tyt-plus-locked>
    </ng-container>
    <tyt-plus-unlocked *ngIf="item.unlock_premium"></tyt-plus-unlocked>
  </div>

  <ul class="stats">
    <li>{{item.duration | duration}}</li>
    <li>
      <tyt-comments-count [identifier]="topicIdentifier"></tyt-comments-count>
    </li>
    <li *ngIf="showEditLink"><a routerLink="/watch/edit/{{production.id}}/{{mode}}/{{item.id}}">Edit</a></li>
  </ul>

</div>

<div class="row" id="feed">
  <div id="social-and-comments" class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
    <div *ngIf="show && mode == 'podcasts'">
      <div class="options-and-social">
        <tyt-social-buttons></tyt-social-buttons>
        <div class="spacer"></div>
        <div class="feed-options" *ngIf="show">
          <span class="available">Available </span>
          <a *ngFor="let provider of getPodcastProviders(show)"
            [responsiveBackgroundImage]="provider.logo_square || provider.logo" [attr.aria-label]="provider.name"
            title="{{provider.name}}" target="_blank" href="{{provider.url}}">
          </a>
          <a routerLink="/podcasts/{{show.id}}" aria-label="Get the members-only podcast on your favorite app"
            title="Members-only Podcast">
            <mat-icon>rss_feed</mat-icon>
          </a>
        </div>
      </div>
    </div>
    <ng-container *ngIf="topicIdentifier">
      <tyt-social-buttons *ngIf="mode != 'podcasts'"></tyt-social-buttons>
      <tyt-comments [identifier]="topicIdentifier" [shareTitle]="topicTitle"></tyt-comments>
    </ng-container>
  </div>
  <div id="sidebar" class="col-lg-4 col-md-4 col-sm-12 col-xs-12">

    <tyt-production-view
      class="mini"
      [production]="production"
      [mode]="mode"
      [playInline]="true"
      [playRemote]="true"
      [showImage]="false"
      [showFeedTag]="true"
      [currentlyPlayingItem]="item"
      (playClicked)="playItem($event, playlist)">
    </tyt-production-view>

    <ng-content selector=".sidebar"></ng-content>
  </div>
</div>